import { all, fork } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import * as auth from './ducks/auth.duck';
import * as users from './ducks/users.duck';
import * as profile from './ducks/profile.duck';
import * as balanceRequest from './ducks/balanceRequest.duck'
import * as transactions from './ducks/transactions.duck'
import * as sendRecive from './ducks/sendRecive.duck'

import { base } from '../../_base';

export type TAppActions =
  | auth.TActions
  | users.TActions
  | profile.TActions
  | balanceRequest.TActions
  | sendRecive.TActions
  | transactions.TActions;

export interface IAppState {
  i18n: typeof base.i18n.reducer;
  builder: typeof base.builder.initialState;
  auth: auth.IInitialState & PersistPartial;
  users: users.IInitialState & PersistPartial;
  profile: profile.IInitialState & PersistPartial;
  balanceRequest:balanceRequest.IInitialState & PersistPartial
  transactions:transactions.IInitialState & PersistPartial
  sendRecive:sendRecive.IInitialState & PersistPartial
}

export const rootReducer: (
  state: IAppState,
  action: TAppActions
) => IAppState = combineReducers<IAppState, TAppActions>({
  auth: auth.reducer,
  users: users.reducer,
  profile: profile.reducer,
  i18n: base.i18n.reducer,
  builder: base.builder.reducer,
  balanceRequest:balanceRequest.reducer,
  transactions:transactions.reducer,
  sendRecive:sendRecive.reducer,
});

export function* rootSaga() {
  yield all(
    [
      auth.saga,
      users.saga,
      profile.saga,
      balanceRequest.saga,
      transactions.saga,
      sendRecive.saga,
    ].map(saga => fork(saga))
  );
}
